module.exports = __webpack_public_path__ + "img/icon_pin_on.39ba8a57.svg";